import { render, staticRenderFns } from "./ArmyToSend.vue?vue&type=template&id=070c62ec&scoped=true&"
import script from "./ArmyToSend.vue?vue&type=script&lang=js&"
export * from "./ArmyToSend.vue?vue&type=script&lang=js&"
import style0 from "./ArmyToSend.vue?vue&type=style&index=0&id=070c62ec&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070c62ec",
  null
  
)

export default component.exports